import { setQueryParams } from './setQueryParams'

export function setSearchQueryParam(
  browser: boolean,
  params: URLSearchParams,
  value: string,
  noScroll?: boolean,
) {
  return setQueryParams({
    browser,
    params: { search: value },
    existingParams: params,
    noScroll,
  })
}

export function setResult(result: unknown[] | null | undefined) {
  return result === null || result?.length === 0 ? null : Boolean(result)
}
